import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=044d4992&scoped=true"
var script = {}
import style0 from "./Login.vue?vue&type=style&index=0&id=044d4992&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044d4992",
  null
  
)

export default component.exports